<template>
  <div></div>
</template>

<script>
export default {
  props: {
    value: {
      type: null,
      default: null
    }
  },

  data() {
    return {
      local_data: null
    }
  },

  created() {
    this.local_data = this.value
  },
  methods: {}
}
</script>

<style lang="scss" scoped></style>
